import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../../util/varios";
import axios from "axios";
import useTableFijo from "../../useTableFijo";
import moment from "moment";
import { Mensaje, MensajeSiNo } from "../../mensajes";
import { Dimmer } from "../../spinner";
const headCells = [
  {
    id: "idfactura",
    label: "PLANILLA",
    width: "30px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "fechaenterami",
    label: "FECHA RETENCIÓN",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "periodo",
    label: "PERIODO",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "numrete",
    label: "N° RETENCIONES",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "montorete",
    label: "MONTO RETENCIONES",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "descristatus",
    label: "STATUS",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "accion",
    label: "",
    width: "100px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];
const TablaHistoricoRetenciones = (props) => {
  const [conexionWeb, setConexionWeb] = useState();
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [activate, setActivate] = useState(false);
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const [records, setRecords] = useState([]);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead } = useTableFijo(
    records,
    headCells,
    filterFn,
    320
  );

  const eliminarRetencion = (peri, status) => (event) => {
    if (status === "Por pagar" || status === "Rechazada") {
      setTitulo("Corfirmar");
      setMsg(
        "Esta seguro de eliminar las Retenciones del período " + peri + " ?"
      );
      setMostrar3(true);
    } else {
      setTitulo("Advertencia");
      setMsg(
        "No se puede eliminar la Retenciones por que se encuentra " +
          status +
          "."
      );
      setMostrar(true);
    }
  };

  const handleCloseNo = () => {
    setMostrar3(false);
  };

  const handleCloseSi = () => {
    setMostrar3(false);
    setActivate(true);
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const seleccionarConexionWeb = () => {
    let campos = "*";
    let nomtab = "basedatos";
    let condi = "tipo = 'web'";
    let orden = "idbasedatos";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setConexionWeb(response.data[0]);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMsg({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const imprimirRetencion = (factura) => (event) => {
    event.preventDefault();
    var reporte = "PlanillaRetencionAcarigua";
    window.open(
      op.reportes +
        "/pagosweb?" +
        "reporte=" +
        reporte +
        "&id=" +
        factura.trim() +
        "&viene=" +
        props.espiritu +
        "&factura=" +
        factura.replace("R", "") +
        "&ip=" +
        conexionWeb.ip +
        "&puerto=" +
        conexionWeb.puerto +
        "&nombre=" +
        conexionWeb.nombre +
        "&contrasena=" +
        conexionWeb.contraseña,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  useEffect(() => {
    seleccionarConexionWeb();
    if (props.tabreten) {
      setRecords(props.tabreten);
    }
  }, [props.tabreten]);

  return (
    <div className = 'col-12 m-0 mt-2 p-0'>
      <div className="col-12 m-0 p-0">
        <TblContainer
          container={{
            height: 250,
            width: "100%",
            overflow: "auto",
            padding: "2px",
          }}
        >
          <TblHead />
          <tbody>
            {records &&
              records.map((item, index) => (
                <tr
                  key={item.idfactura + item.periodo}
                  style={{ padding: "0" }}
                >
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {"R" + item.idfactura}
                  </td>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {moment.utc(item.fechaenterami).format("DD/MM/YYYY")}
                  </td>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {item.periodo}
                  </td>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {item.numrete}
                  </td>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {formatMoneda(
                      item.montorete.toString().replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  </td>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {item.descristatus}
                  </td>
                  <td
                    align="center"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "60px",
                      padding: 0,
                    }}
                  >
                    <button
                      style={{ width: "40px" }}
                      onClick={imprimirRetencion(item.idfactura)}
                      className="btn btn-primary"
                    >
                      <i className="fas fa-print"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    {props.operacion === 2 ? (
                      <button
                        style={{ width: "40px" }}
                        onClick={eliminarRetencion(
                          item.agenteretencion,
                          item.periodo,
                          item.descristatus
                        )}
                        className="btn btn-danger"
                      >
                        <i className="fas fa-trash-alt"></i>{" "}
                      </button>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
      </div>
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />
      <MensajeSiNo
        titulo={titulo}
        mensaje={msg}
        show={mostrar3}
        onHideSi={handleCloseSi}
        onHideNo={handleCloseNo}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
};
export default TablaHistoricoRetenciones;
